const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
 * @function evaluate - evaluates isMemberOfBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  let result;
  const input = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  if (Array.isArray(input)) {
    const compareValue = await evaluateSource(source.compareValue, content, parentContentPath, transientContext, nativeFunctions);
    result = input.includes(compareValue);
  }
  return result;
};
module.exports = {
  evaluate
};